/** Underground hub: rank titles, achievement labels, flex copy. */

export function arcadeUndergroundTitle(level) {
  const L = Math.max(1, Math.floor(Number(level) || 1));
  if (L >= 40) return "Phantom operator";
  if (L >= 28) return "Wire chief";
  if (L >= 18) return "Backroom regular";
  if (L >= 12) return "Connected player";
  if (L >= 7) return "Runner";
  if (L >= 3) return "Street known";
  return "New face";
}

const ACHIEVEMENT_LABELS = {
  arcade_level_5: "Established · Lv 5",
  arcade_level_15: "Veteran · Lv 15",
  trivia_streak_10: "Legacy streak ×10",
};

export function achievementDisplayName(id) {
  if (!id) return id;
  return ACHIEVEMENT_LABELS[id] || id.replace(/_/g, " ");
}

export function formatAchievementList(ids) {
  if (!ids?.length) return [];
  return ids.map(achievementDisplayName);
}
